import { Box, Card, SxProps } from '@mui/material';
import BarChart from '../../components/charts/BarChart';
import { Productivity } from '../../services/configApi/activitySheet/weeklyActivitySheetProvider';
import { FC } from 'react';
import {
  getBackgroundColors,
  productivityData,
  productivityLabels,
} from './activityUtils';
import ButtonComponent from '../../components/formlib/ButtonComponent';

interface ProductivityChartProps {
  productivity: Productivity[] | null;
  cardStyle?: SxProps;
  horizontalValue: number | null;
  barHeight: string;
  viewProductivity?: () => void;
}

const ProductivityChart: FC<ProductivityChartProps> = ({
  productivity,
  cardStyle,
  horizontalValue,
  barHeight,
  viewProductivity,
}) => {
  return (
    <Card
      sx={{
        padding: '16px 8px 8px 12px',
        ...cardStyle,
        alignContent: 'center',
      }}
    >
      {productivity ? (
        <BarChart
          barHeight={barHeight}
          labels={productivityLabels(productivity)}
          data={productivityData(productivity)}
          barPercentage={0.5}
          horizontalValue={horizontalValue ?? 0}
          backgroundColors={getBackgroundColors(productivity)}
        />
      ) : (
        <Box sx={{ justifyContent: 'center', display: 'flex' }}>
          <ButtonComponent
            type="submit"
            variantType="contained"
            labelId="viewProductivityText"
            className="btn-primary btn-submit"
            defaultLabelId="View Productivity"
            onClick={viewProductivity}
          />
        </Box>
      )}
    </Card>
  );
};

export default ProductivityChart;
